<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Integration Status')"></h1>
        <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
    </div>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <app-common-notifications-eventlogs [resourceId]="instanceId" [notificationsState]="notificationsState"></app-common-notifications-eventlogs>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
